const campusGroupAdmins = {
  all_campus_group_admins: '🏫 Todos los administradores de grupo de sede',
  create: 'Crear Nuevo Administrador de Grupo de Sede',
  firstname: 'Nombre',
  lastname: 'Apellido Paterno',
  lastname2nd: 'Apellido Materno',
  email: 'Correo Electrónico',
  dni: 'DNI',
  birth_date: 'Fecha de Nacimiento',
  campus_group: 'Grupo de Sede',
  general_information: 'Información General',
  select_campus_group: 'Seleccionar Grupo de Sede',
  search_by_name: 'Buscar por nombre',
};

export default campusGroupAdmins;
